import React, { useState } from "react";
import axios from "axios";
import axiosInstance from "../../../utils/axiosInstance";
import { Link } from "react-router-dom";

export default function Addcake() {
  const [newProduct, setNewProduct] = useState({
    name: "",
    price: "",
    image: null, // Updated to use null for the image state
    description: "",
    iscake: true, // Initialize iscake as a boolean
    ingredients: "", // Initialize iscake as a boolean
    category: "", // Initialize iscake as a boolean
  });
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const handleInputChange = (fieldName, value) => {
    setNewProduct((prevNewProduct) => ({
      ...prevNewProduct,
      [fieldName]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNewProduct((prevNewProduct) => ({
      ...prevNewProduct,
      image: file,
    }));
  };

  const addProduct = async () => {
    const token = localStorage.getItem("token");
    try {
      if (newProduct.name && newProduct.price && newProduct.image) {
        const formData = new FormData();
        formData.append("name", newProduct.name);
        formData.append("price", newProduct.price);
        formData.append("image", newProduct.image);
        formData.append("description", newProduct.description);
        formData.append("iscake", newProduct.iscake);
        formData.append("ingredients", newProduct.ingredients);
        formData.append("category", newProduct.category);

        const response = await axiosInstance.post(
          "/api/products/add-products",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              token: `Bearer ${token}`,
            },
          }
        );

        // Assuming the API returns the newly added product
        const addedProduct = response.data;

        console.log("Product added:", addedProduct);

        // Clear the input fields and close the popup
        setNewProduct({ name: "", price: "", image: null, description: "" });
        closePopup();
      } else {
        alert("Please fill in all fields.");
      }
    } catch (error) {
      console.error("Error adding product:", error);
    }
  };

  const formFields = [
    {
      name: "name",
      type: "text",
      placeholder: "Product Name",
      label: "Write cake  name",
    },
    {
      name: "price",
      type: "number",
      placeholder: "Price",
      label: "Write cake Price",
    },
    {
      name: "image",
      type: "file",
      placeholder: "Upload Image",
      label: "Provide cake image compressed",
    },
    {
      name: "description",
      type: "text",
      placeholder: "description",
      label: "Provide cake  Description",
    },
    {
      name: "ingredients",
      type: "text",
      placeholder: "ingredients use comma",
      label: "Write some ingredients",
    },
    // { name: 'category', type: 'text', placeholder: 'cake category', label:"Select or Create a new category for cake" },
    {
      name: "category",
      type: "select",
      label: "Select a category",
      options: [
        { value: "chocolate", label: "chocolate" },
        { value: "vanilla", label: "vanilla" },
        { value: "redvelvet", label: "redvelvet" },
        { value: "blackforest", label: "blackforest" },
        { value: "whiteforest", label: "whiteforest" },
        // Add more options as needed
      ],
    },
  ];

  return (
    <div>
      <div className="bg-gray-800 py-2 px-4 rounded-md">
        <ul className="flex text-white">
          <li className="mr-2">
            <Link to="/" className="hover:text-amber-500 transition">
              Home
            </Link>
          </li>
          <li className="mr-2">/</li>
          <li className="mr-2">
            <Link to="/products" className="hover:text-amber-500 transition">
              Products
            </Link>
          </li>
        </ul>
      </div>
      <div
        className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 mb-2 flex items-center"
        role="alert"
      >
        <svg
          className="fill-current w-4 h-4 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M12.432 0c1.34 0 2.01.912 2.01 1.957 0 1.305-1.164 2.512-2.679 2.512-1.269 0-2.009-.75-1.974-1.99C9.789 1.436 10.67 0 12.432 0zM8.309 20c-1.058 0-1.833-.652-1.093-3.524l1.214-5.092c.211-.814.246-1.141 0-1.141-.317 0-1.689.562-2.502 1.117l-.528-.88c2.572-2.186 5.531-3.467 6.801-3.467 1.057 0 1.233 1.273.705 3.23l-1.391 5.352c-.246.945-.141 1.271.106 1.271.317 0 1.357-.392 2.379-1.207l.6.814C12.098 19.02 9.365 20 8.309 20z" />
        </svg>

        <div className="">
          <p className="font-bold">Informational message</p>
          <p className="text-sm">Add product details here.</p>
          <p className="text-sm">
            Click the below products to update and delete.
          </p>
        </div>
      </div>

      <button
        onClick={openPopup}
        className="p-2 bg-blue-500 text-white rounded flex items-center mb-4"
      >
        <span className="mr-2">+</span> Add New Product
      </button>

      {isPopupOpen && (
        <div className="bg-white p-8 rounded-md shadow-md fixed top-1/2 left-1/2 transform z-40 -translate-x-1/2 -translate-y-1/2">
          <h2 className="text-2xl font-bold mb-4">Add New Product</h2>
          <div className="flex flex-col p-2">
          {formFields.map((field) => (
  <div key={field.name} className="mb-4">
    <label
      htmlFor={field.name}
      className="block text-sm font-medium text-gray-700"
    >
      {field.label}
    </label>

    {field.type === "select" ? (
      <div>
        <select
          id={field.name}
          name={field.name}
          value={newProduct[field.name]}
          onChange={(e) => handleInputChange(field.name, e.target.value)}
          className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500 sm:text-sm"
        >
          <option value="" disabled>
            Select an option
          </option>
          {field.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
                  <option value="addNew">Add New</option>

        </select>

        {newProduct[field.name] === 'addNew' && (
          <div className="mt-2">
            <input
              type="text"
              placeholder="New Category"
              value={newProduct.newCategory || ''}
              onChange={(e) => handleInputChange('newCategory', e.target.value)}
              className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500 sm:text-sm"
            />
          </div>
        )}
      </div>
    ) : (
      <input
        type={field.type}
        name={field.name}
        placeholder={field.placeholder}
        value={
          field.type === "file" ? undefined : newProduct[field.name]
        }
        onChange={(e) =>
          field.type === "file"
            ? handleImageChange(e)
            : handleInputChange(field.name, e.target.value)
        }
        className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring focus:border-blue-500 sm:text-sm"
      />
    )}
  </div>
))}


            <div className="mt-4">
              <button
                onClick={addProduct}
                className="p-2 bg-blue-500 text-white rounded"
              >
                Add Product
              </button>
              <button
                onClick={closePopup}
                className="p-2 ml-2 bg-gray-500 text-white rounded"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
